export class LibraryGroup {
  type: string;
  id: string;
  name: string;
  children: {}[];
}
